/**
 * Wealthica data persistence mutation
 * 
 * Handles saving account and position data to the database
 * Separated from reconnection logic for clean separation of concerns
 */

import { useMutation } from '@tanstack/react-query';
import { useMultiWealthica2Store } from '@/stores/multiWealthica2Store';
import { logger } from '@/services/LoggingService';
import type { WealthicaConnection, WealthicaAccount } from '../../types';

interface PersistParams {
  userId: string;
  connectionData: WealthicaConnection;
  accounts: WealthicaAccount[];
}

export function useWealthicaPersistMutation() {
  // Multi-store only
  const multiStore = useMultiWealthica2Store();

  return useMutation<void, Error, PersistParams>({
    mutationFn: async ({ userId, connectionData, accounts }) => {
      logger.info('useWealthicaPersistMutation', 'Starting data persistence', {
        storeMode: 'multi-store',
        accountCount: accounts?.length || 0,
        institutionId: connectionData.institutionId
      });

      // Multi-store mode - enable persistence preference
      multiStore.setPersistDataPreference(true);
      logger.info('useWealthicaPersistMutation', 'Multi-store persistence enabled');

      logger.info('useWealthicaPersistMutation', 'Data persistence completed');
    },
    onError: (error) => {
      logger.error('useWealthicaPersistMutation', 'Data persistence failed', { error });
    }
  });
}
